export interface ImportOption {
  name: string
  id?: string | number
  description?: string
  isDefault?: boolean
  value?: string | number
}
export interface ImportSelectOption {
  label: string
  value: string | number | null
}

export interface FieldMapping {
  key: keyof OptionsMap
  options: ImportOption[]
}

export interface OptionsMap {
  salesTeams: ImportSelectOption[]
  salesFunnels: ImportSelectOption[]
  branches: ImportSelectOption[]
  leadSources: ImportSelectOption[]
  campaigns: ImportSelectOption[]
  targetPests: ImportSelectOption[]
  locationTypes: ImportSelectOption[]
  statesProvinces: ImportSelectOption[]
  divisions: ImportSelectOption[]
  users: ImportSelectOption[]
  salesFunnelLeadStages: ImportSelectOption[]
  salesFunnelOpportunityStages: ImportSelectOption[]
  frequencies: ImportSelectOption[]
  referralTypes: ImportSelectOption[]
  services: ImportSelectOption[]
  contactTimes: ImportSelectOption[]
  contactMethods: ImportSelectOption[]
}

export enum ImportEntityType {
  Lead = 0,
  Opportunity = 1,
  DraftLead = 2,
}

export type ActionMode = 'init' | 'update'

export function entityTypeToImportType(entityType: ImportEntityType) {
  switch (entityType) {
    case ImportEntityType.Lead:
      return 'leads'
    case ImportEntityType.Opportunity:
      return 'opportunities'
    case ImportEntityType.DraftLead:
      return 'pendingLeads'
    default:
      return 'pendingLeads'
  }
}
